module.exports = __webpack_public_path__ + "media/images/project/delete-project-06a6c5abbd9b5447eeae19248c0d3811.svg";